import type { CharacterBrief } from '../api/types';

interface Props {
  readonly brief: Pick<CharacterBrief, 'name' | 'portrait' | 'emoji'>;
  readonly size: number;
  readonly className: string;
  readonly loading?: 'lazy' | 'eager';
}

/**
 * キャラの顔。テーマの絵（生成テーマは Gemini が描いたもの。できるまでは絵文字）。
 * 同じ枠に収めて、どちらでも画面が崩れないようにする。
 */
export function Portrait({ brief, size, className, loading }: Props) {
  if (brief.portrait) {
    return <img className={className} src={brief.portrait} alt={`${brief.name}のイラスト`} width={size} height={size} loading={loading} />;
  }
  return (
    <span
      className={`${className} portrait--emoji`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.55) }}
      role="img"
      aria-label={brief.name}
    >
      {brief.emoji ?? '✨'}
    </span>
  );
}
